/**
 * Video ad lifecycle event names — IMA/VAST/VMAP measurement contract.
 * Maps cleanly to Google IMA AdsManager events when the client is activated.
 */

export var VideoAdLifecycle = Object.freeze({
  AD_REQUEST: "AD_REQUEST",
  AD_RESPONSE: "AD_RESPONSE",
  AD_IMPRESSION: "AD_IMPRESSION",
  AD_START: "AD_START",
  AD_FIRST_QUARTILE: "AD_FIRST_QUARTILE",
  AD_MIDPOINT: "AD_MIDPOINT",
  AD_THIRD_QUARTILE: "AD_THIRD_QUARTILE",
  AD_COMPLETE: "AD_COMPLETE",
  AD_SKIP: "AD_SKIP",
  AD_CLICK: "AD_CLICK",
  AD_CLICK_TRACKING: "AD_CLICK_TRACKING",
  AD_ERROR: "AD_ERROR",
  AD_POD_START: "AD_POD_START",
  AD_POD_END: "AD_POD_END",
  AD_COMPANION: "AD_COMPANION",
  AD_NO_FILL: "AD_NO_FILL",
  AD_FALLBACK: "AD_FALLBACK",
  AD_BREAK_START: "AD_BREAK_START",
  AD_BREAK_END: "AD_BREAK_END",
});

export default VideoAdLifecycle;
